import controller from '../../../../Scripts/Controller.js';

function CoursesController(container) {

    const savedCoursesKey = container.dataset.courseStorageId ?? "courses";

    function init() {
         
        loadCourses();

        function loadCourses() {

            const courseIds = getAllCourseIds();

            $.ajax({
                url: '/SavedCoursesPage/GetListCourses/',
                type: 'POST',
                contentType: 'application/json',
                data: JSON.stringify(courseIds),
                success: function (courses) {
                    // Render courses in DOM.
                    $('#coursesContainer').html(courses);
                    attatchEventListeners();
                },
                error: function (error) {
                    console.error("Error loading courses: ", error);
                }
            });
        }

        function attatchEventListeners() {

            // Add courses-ids to this list to compare if a course has been removed.
            let existingCourses = [];

            var articles = container.querySelectorAll('.grid__item[data-course-id]');
            articles.forEach(function (article) {

                var courseId = parseInt(article.dataset.courseId, 10);

                existingCourses.push(courseId);

                var removeButton = article.querySelector('#remove-saved-course');
                if (removeButton) {
                    removeButton.addEventListener('click', function () {
                        removeCourseId(courseId);
                        updateCoursesCountDisplay();

                        article.remove();
                    });
                }

            });

            compareLocalStorageToExistingCourses(existingCourses);
        }

        function compareLocalStorageToExistingCourses(existingCourses) {

            if (existingCourses.length != countSavedCourseIds()) {
                var removedItems = countSavedCourseIds() - existingCourses.length;
                var statusElement = container.querySelector('#status-message');
                statusElement.textContent = removedItems + " av dina " + countSavedCourseIds() + " favoriter har blivit borttagna då sidan avpublicerats.";
            }

            let courses = getAllCourseIds();
            courses.forEach(function (courseId) {
                if (!existingCourses.includes(parseInt(courseId, 10))) {
                    removeCourseId(courseId);
                }
            });
        }


        function removeCourseId(courseId) {
            let courses = localStorage.getItem(savedCoursesKey);
            if (courses) {
                courses = JSON.parse(courses);
                courses = courses.filter(id => id !== courseId.toString());
                localStorage.setItem(savedCoursesKey, JSON.stringify(courses));
            }

            updateCoursesCountDisplay();
        }

        function getAllCourseIds() {
            const courses = localStorage.getItem(savedCoursesKey);
            return courses ? JSON.parse(courses) : [];
        }

        function countSavedCourseIds() {
            const courses = localStorage.getItem(savedCoursesKey);
            return courses ? JSON.parse(courses).length : 0;
        }

        function updateCoursesCountDisplay() {
            const count = countSavedCourseIds();
            const displayElements = document.querySelectorAll('#saved-courses-count');

            displayElements.forEach(function (element) {
                element.textContent = count;
            });
        }

    }

    return {
        init: init
    }

}

controller.add('CoursesController', CoursesController);
export default CoursesController;
